exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Sidebar__container{background:#fff;border:none;border-right:1px solid #aaa;bottom:0;opacity:.95;overflow-y:auto;padding:20px;position:absolute;top:0;transition:transform .2s ease;z-index:1}.Sidebar__container.Sidebar__left{left:0}.Sidebar__container.Sidebar__left.Sidebar__hidden{transform:translateX(calc(-100% + 7px))}", ""]);

// exports
exports.locals = {
	"container": "Sidebar__container",
	"left": "Sidebar__left",
	"hidden": "Sidebar__hidden"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":true,"localIdentName":"[name]__[local]"}!./client/components/Sidebar.css
// module id = 23
// module chunks = 0